(() => {
  if(window.ppTrustLoaded)return;
  window.ppTrustLoaded=true;
  let ratingSource;
  document.addEventListener('click',event=>{
    const open=event.target.closest('[data-pp-trust-open]');
    if(open){const dialog=open.closest('[data-pp-trust]').querySelector('[data-pp-trust-dialog]');if(dialog&&!dialog.open)dialog.showModal();return;}
    const close=event.target.closest('[data-pp-trust-close]');if(close){close.closest('dialog').close();return;}
    if(event.target.matches('[data-pp-trust-dialog]')){const b=event.target.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)event.target.close();}
  });
  const mobileTrust=window.matchMedia('(max-width:899px)');
  const positions=new Map();
  const cacheKey='pp-webwinkelkeur-rating-v1';
  const applyRating=data=>{
    document.querySelectorAll('[data-pp-trust]').forEach(target=>{
      target.querySelectorAll('[data-pp-wwk-score-number]').forEach(n=>n.textContent=data.score.replace('.',','));
      target.querySelectorAll('[data-pp-wwk-logo]').forEach(n=>{if(data.logo&&data.logo!=='none'){n.style.backgroundImage=data.logo;n.hidden=false;}});
      target.querySelectorAll('[data-pp-wwk-score]').forEach(n=>n.textContent=data.score+' / 10');
      target.querySelectorAll('[data-pp-wwk-count]').forEach(n=>n.textContent=Number(data.count).toLocaleString(document.documentElement.lang||'nl'));
      target.hidden=false;
    });
  };
  const showMobileTrust=()=>{
    document.querySelectorAll('[data-pp-trust]').forEach(target=>{
      if(!positions.has(target)){const anchor=document.createComment('pp-trust-position');target.before(anchor);positions.set(target,anchor);}
      if(mobileTrust.matches){const header=document.querySelector('.pp-header-wrapper');if(header&&target.nextElementSibling!==header)header.before(target);target.hidden=false;}
      else{const anchor=positions.get(target);if(anchor.parentNode&&anchor.nextSibling!==target)anchor.after(target);}
    });
    if(document.querySelector('[data-pp-trust]'))document.documentElement.classList.add('pp-trust-ready');
  };
  try{const saved=JSON.parse(localStorage.getItem(cacheKey));if(saved&&Date.now()-saved.time<86400000&&/^\d+[,.]\d+$/.test(saved.score)&&/^\d+$/.test(saved.count))applyRating(saved);}catch{}
  showMobileTrust();
  mobileTrust.addEventListener('change',()=>{showMobileTrust();sync();});
  const sync=()=>{
    const source=document.querySelector('#wwkSidebarFloat .wwk-sidebar__rating-wrapper');
    if(!source)return false;
    const score=(source.querySelector('.wwk-sidebar__rating')?.textContent || '').match(/\d+[,.]\d+/)?.[0];
    const count=(source.querySelector('.wwk-sidebar__rating-count')?.textContent || '').replace(/[^\d]/g,'');
    if(!score || !count)return false;
    const logo=document.querySelector('#wwkSidebarFloat .wwk-sidebar__logo');
    const logoImage=logo ? getComputedStyle(logo).backgroundImage : 'none';
    applyRating({score,count,logo:logoImage});
    if(logoImage!=='none'){try{localStorage.setItem(cacheKey,JSON.stringify({score,count,logo:logoImage,time:Date.now()}));}catch{}}
    if(document.querySelector('[data-pp-trust]'))document.documentElement.classList.add('pp-trust-ready');
    if(ratingSource!==source){ratingSource=source;const observer=new MutationObserver(sync);observer.observe(document.querySelector('#wwkSidebarFloat'),{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['style','class']});}
    return true;
  };
  if(!sync()){
    const observer=new MutationObserver(()=>{if(sync())observer.disconnect();});
    observer.observe(document.body,{subtree:true,childList:true});
    
  }
  document.addEventListener('shopify:section:load',()=>{showMobileTrust();sync();});
  document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(()=>{if(!document.querySelector('[data-pp-trust]'))document.documentElement.classList.remove('pp-trust-ready');}));
})();
